import { Fragment, useEffect } from "react";

import { Auth0Context, Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { useEnv } from "../context/env.context";

export const Logout: React.FC = () => {
	const { logout } = useAuth0();

	const { webAppUrl, clientId } = useEnv();

	useEffect(() => {
		let redirectUrl = sessionStorage.getItem("returnToAp1");
		let redirectUser = sessionStorage.getItem("redirectOnLogOut");

		let returnToUrl = webAppUrl;

		if (redirectUser === "true" && redirectUrl) {
			// redirect user only if they have come from AP1
			sessionStorage.setItem("redirectUser", "");
			sessionStorage.setItem("returnToAp1", "");
			returnToUrl = redirectUrl;
		}

		sessionStorage.clear();
		logout({
			returnTo: returnToUrl,
			client_id: clientId
		});
	}, []);

	return <Fragment></Fragment>;
};
